import { ObjectColumn } from '../types/grid';
import { ColumnOptionsBase, ServerSideColumnOption } from '../types/column-options';
import { EntityColumnRef, GridRef, GroupColumnRef } from '../types/refs';

export interface ClientSideObjectColumnOptions<TRow extends object, TValue> extends ColumnOptionsBase<TRow, TValue> {
  format: (value: TValue) => string;
  sortBy: (value: TValue) => number | string;
  rowGroup?: boolean;
}

export interface ServerSideObjectColumnOptions<TRow extends object, TValue> extends ColumnOptionsBase<TRow, TValue>, ServerSideColumnOption {
  format: (value: TValue) => string;
  sortBy: (value: TValue) => number | string;
  serverSideSortField: string;
  rowGroup?: boolean;
}

export type ObjectColumnOptions<TRow extends object, TValue> = ClientSideObjectColumnOptions<TRow, TValue> | ServerSideObjectColumnOptions<TRow, TValue>;

export function objectColumn<TRow extends object, TValue extends object>(ref: GridRef<TRow> | GroupColumnRef<TRow> | EntityColumnRef<TRow>,
                                                                         options: ObjectColumnOptions<TRow, TValue> | ServerSideObjectColumnOptions<TRow, TValue>): ObjectColumn<TRow, TValue> {
  const column: ObjectColumn<TRow, TValue> = {
    ...options,
    type: 'object',
  }
  ref.createColumn(column as any);
  return column;
}
